import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
import { useRef, useState } from 'react';
import { X, ArrowRight } from 'lucide-react';

const TALLY_FORM_URL = "https://tally.so/r/lbRGGp";

export const QuizSection = () => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: "-100px" });
  const [isQuizOpen, setIsQuizOpen] = useState(false);

  return (
    <>
      <section
        data-testid="quiz-section"
        ref={ref}
        className="py-16 md:py-24 lg:py-32 bg-white"
      >
        <div className="container-peak">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={isInView ? { opacity: 1, y: 0 } : {}}
            transition={{ duration: 0.6 }}
            className="max-w-3xl mx-auto text-center"
          >
            <span className="section-tag block mb-4 lg:mb-6">Take The Test</span>
            <h2 className="text-2xl sm:text-3xl lg:text-4xl xl:text-5xl font-light leading-[1.15] mb-4 lg:mb-6 text-[#1F2A44]">
              Signal vs Noise <em className="not-italic text-[#D97904]">Detection Test</em>
            </h2>
            <p className="text-[#5A6B7A] text-sm lg:text-base mb-8 lg:mb-10 max-w-xl mx-auto">
              Discover where you fall on the spectrum. Are you engineering signal or drowning in noise?
            </p>
            
            <motion.button
              onClick={() => setIsQuizOpen(true)}
              whileHover={{ scale: 1.02 }}
              whileTap={{ scale: 0.98 }}
              className="btn-primary inline-flex items-center gap-3"
            >
              Start the Test
              <ArrowRight size={16} />
            </motion.button>
          </motion.div>
        </div>
      </section>

      {/* Quiz Modal with Tally Form */}
      {isQuizOpen && (
        <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/60 backdrop-blur-sm">
          <motion.div
            initial={{ opacity: 0, scale: 0.95 }}
            animate={{ opacity: 1, scale: 1 }}
            exit={{ opacity: 0, scale: 0.95 }}
            className="bg-white w-full max-w-2xl h-[80vh] rounded-none shadow-2xl relative flex flex-col"
          >
            {/* Close button */}
            <button
              onClick={() => setIsQuizOpen(false)}
              className="absolute top-4 right-4 text-[#5A6B7A] hover:text-[#1F2A44] transition-colors z-10 bg-white rounded-full p-1"
            >
              <X size={24} />
            </button>

            {/* Tally Form Embed */}
            <div className="flex-1 overflow-hidden">
              <iframe
                src={TALLY_FORM_URL}
                width="100%"
                height="100%"
                frameBorder="0"
                marginHeight="0"
                marginWidth="0"
                title="Signal vs Noise Detection Test"
                style={{ border: 'none' }}
              />
            </div>
          </motion.div>
        </div>
      )}
    </>
  );
};

export default QuizSection;
